module.exports = __webpack_public_path__ + "img/frame-mb.34fed242.webp";